export default __webpack_public_path__ + "static/media/trener8.605c02f5.png";